export function RouteFallback({ label = "Loading…" }: { label?: string }) {
  return <p className="muted">{label}</p>;
}
